<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="queryParams" ref="queryForm" label-width="130px" size="small" inline>


        <el-form-item label="流水订单号" prop="orderNo" >
           <span style="display: inline-flex; align-items: center;">
          <el-input v-model="queryParams.orderNo" placeholder="请输入订单号" clearable />
          <el-button type="text" @click="openMoreDialog('orderNo')">More</el-button>
               </span>
        </el-form-item>

<!--        <el-form-item label="银行订单号" prop="bankOrderNo" >
           <span style="display: inline-flex; align-items: center;">
          <el-input v-model="queryParams.bankOrderNo" placeholder="请输入银行订单号" clearable />
          <el-button type="text" @click="openMoreDialog('bankOrderNo')">More</el-button>
               </span>
        </el-form-item>-->

        <el-form-item label="商户订单号" prop="trMerOrderno" >
           <span style="display: inline-flex; align-items: center;">
          <el-input v-model="queryParams.trMerOrderno" placeholder="请输入商户订单号" clearable />
          <el-button type="text" @click="openMoreDialog('trMerOrderno')">More</el-button>
               </span>
        </el-form-item>

        <el-form-item label="地址" prop="address">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.address" placeholder="请输入地址" clearable />
            <el-button type="text" @click="openMoreDialog('address')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="电话" prop="ciTel">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.ciTel" placeholder="请输入电话" clearable />
            <el-button type="text" @click="openMoreDialog('ciTel')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="商户号" prop="merNo">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.merNo" placeholder="请输入商户号" clearable />
            <el-button type="text" @click="openMoreDialog('merNo')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="商户号别名" prop="merNo1">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.merNo1" placeholder="请输入商户号别名" clearable />
            <el-button type="text" @click="openMoreDialog('merNo1')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="IP地址" prop="ipAddress">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.ipAddress" placeholder="请输入ip地址" clearable />
            <el-button type="text" @click="openMoreDialog('ipAddress')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="邮箱" prop="ciEmail">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.ciEmail" placeholder="请输入邮箱" clearable />
            <el-button type="text" @click="openMoreDialog('ciEmail')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="姓名" prop="fullName">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.fullName" placeholder="请输入姓名" clearable />
            <el-button type="text" @click="openMoreDialog('fullName')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="cardSha" prop="cardSha">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.cardSha" placeholder="请输入cardSha" clearable />
            <el-button type="text" @click="openMoreDialog('cardSha')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="卡号" prop="cardnopart">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.cardnopart" placeholder="请输入卡号" clearable />
            <el-button type="text" @click="openMoreDialog('cardnopart')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="卡所属国家" prop="ciCountry" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.ciCountry" placeholder="请输入卡所属国家" clearable />
            <el-button type="text" @click="openMoreDialog('ciCountry')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="发卡行" prop="cilsuingBank" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.cilsuingBank" placeholder="请输入发卡行" clearable />
            <el-button type="text" @click="openMoreDialog('cilsuingBank')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="Risk发卡行" prop="experianCardIssuer" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.experianCardIssuer" placeholder="请输入Risk发卡行" clearable />
            <el-button type="text" @click="openMoreDialog('experianCardIssuer')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>




<!--        <el-form-item label="名" prop="firstname">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.firstname" placeholder="请输入名" clearable />
            <el-button type="text" @click="openMoreDialog('firstname')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="姓" prop="lastname">
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.lastname" placeholder="请输入姓" clearable />
            <el-button type="text" @click="openMoreDialog('lastname')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>-->



        <el-form-item label="交易状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
            <el-option label="成功" value="1"></el-option>
            <el-option label="失败" value="0"></el-option>
            <el-option label="待确认" value="-2"></el-option>
            <el-option label="待处理" value="-1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="退款状态" prop="refundment">
          <el-select v-model="queryParams.refundment" placeholder="请选择状态" clearable>
            <el-option label="已退款" value="1"></el-option>
            <el-option label="未退款" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="拒付状态" prop="protest">
          <el-select v-model="queryParams.protest" placeholder="请选择状态" clearable>
            <el-option label="已拒付" value="1"></el-option>
            <el-option label="未拒付" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="冻结状态" prop="congeal">
          <el-select v-model="queryParams.congeal" placeholder="请选择状态" clearable>
            <el-option label="已冻结" value="1"></el-option>
            <el-option label="未冻结" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡种" prop="ciCardtype">
          <el-select v-model="queryParams.ciCardtype" placeholder="请选择状态" clearable>
            <el-option label="Visa" value="1"></el-option>
            <el-option label="Master" value="2"></el-option>
            <el-option label="JCB" value="3"></el-option>
            <el-option label="AE" value="4"></el-option>
            <el-option label="DC" value="5"></el-option>
            <el-option label="DISCOVER" value="6"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账单地址" prop="ciAcquirer" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.ciAcquirer" placeholder="请输入账单地址" clearable />
            <el-button type="text" @click="openMoreDialog('ciAcquirer')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="通道代码" prop="trChaCode" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.trChaCode" placeholder="请输入通道代码" clearable />
            <el-button type="text" @click="openMoreDialog('trChaCode')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="通道名称" prop="chaName" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.chaName" placeholder="请输入通道名称" clearable />
            <el-button type="text" @click="openMoreDialog('chaName')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>

        <el-form-item label="Risk卡所属国家" prop="mopCardCountry" >
           <span style="display: inline-flex; align-items: center;">
            <el-input v-model="queryParams.mopCardCountry" placeholder="请输入Risk卡所属国家" clearable />
            <el-button type="text" @click="openMoreDialog('mopCardCountry')" style="margin-left: 8px;">More</el-button>
           </span>
        </el-form-item>


        <!-- 开始时间 -->
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="queryParams.startTime"
            type="datetime"
            placeholder="选择开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 210px;"
          />
        </el-form-item>

        <!-- 结束时间 -->
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="queryParams.endTime"
            type="datetime"
            placeholder="选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 210px;"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
<!--          <el-button type="primary" @click="downloadCsv">下载 CSV</el-button>-->
          <form
            action="/api/es/exportTrades"
            method="POST"
            target="_blank"
            @submit="onDownloadSubmit"
            style="display: inline-block; margin-left: 10px;"
          >
            <input type="hidden" name="params" :value="JSON.stringify(queryParams)">
            <el-button
              native-type="submit"
              :disabled="!hasSearched"
              type="success"
            >
              <i class="el-icon-download"></i>
              下载
            </el-button>
          </form>
<!--          <el-button
            @click="downloadCsv"
            :disabled="!hasSearched"
            type="success"
          >
            <i class="el-icon-download"></i>
            下载
          </el-button>-->
        </el-form-item>


        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
          :visible.sync="moreDialogVisible"
          width="500px"
          @close="onMoreDialogClose"
        >
          <el-input
            type="textarea"
            :rows="8"
            v-model="moreInput"
            :placeholder="`请输入多个值,请使用#隔开。例如：\nVALUE1\nVALUE2# VALUE3`"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">取消</el-button>
    <el-button type="primary" @click="confirmMoreInput">确定</el-button>
  </span>
        </el-dialog>
      </el-form>
    </el-card>

    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >
        <el-table-column prop="tr_no" label="流水订单号" width="210"></el-table-column>
        <el-table-column prop="tr_mer_orderno" label="商户订单号" width="210"></el-table-column>
        <el-table-column prop="tr_mer_no" label="商户号"></el-table-column>
        <el-table-column prop="tr_gw_no" label="网关接入号"></el-table-column>
        <el-table-column prop="tr_bank_code" label="支付银行" width="110"></el-table-column>
        <el-table-column prop="cha_name" label="通道"></el-table-column>
<!--        <el-table-column prop="tr_bankcurrency" label="收单币种"></el-table-column>-->
<!--        <el-table-column prop="tr_bankamout" label="收单金额"></el-table-column>-->
        <el-table-column label="收单金额" width="100">
          <template #default="scope">
            <span>{{ scope.row.tr_bankcurrency }} {{ scope.row.tr_bankamout }}</span>
          </template>
        </el-table-column>


        <el-table-column prop="tr_status" label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="statusMap[row.tr_status]">{{ statusText[row.tr_status] }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="tr_bankinfo" label="银行返回信息"></el-table-column>

<!--        <el-table-column prop="TR_CURRENCY" label="交易币种"></el-table-column>
        <el-table-column prop="tr_amount" label="交易金额"></el-table-column>-->
        <el-table-column label="交易金额" width="100">
          <template #default="scope">
            <span>{{ scope.row.tr_currency }} {{ scope.row.tr_amount }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="tr_datetime" label="交易时间" width="180">
          <template #default="scope">
            <span>{{ formatTime(scope.row.tr_datetime) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="ci_cardnopart" label="卡号"></el-table-column>
        <el-table-column prop="ci_country" label="卡所属国"></el-table-column>
        <el-table-column prop="ci_issuingbank" label="发卡行"></el-table-column>

<!--        <el-table-column prop="full_name" label="姓名"></el-table-column>-->
        <el-table-column prop="full_name" label="姓名">
          <template slot-scope="{ row }">
            <span style="white-space: pre-wrap;">{{ row.full_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ci_email" label="邮箱"></el-table-column>
        <el-table-column prop="ci_tel" label="联系电话"></el-table-column>
        <el-table-column prop="ci_address" label="地址"></el-table-column>
        <el-table-column prop="ci_ipaddress" label="ip地址"></el-table-column>
        <el-table-column prop="ci_ipcountry" label="ip所在国家"></el-table-column>
        <el-table-column prop="tr_isfraud" label="伪冒状态"></el-table-column>
        <el-table-column prop="tr_refundment" label="退款状态"></el-table-column>
        <el-table-column prop="tr_protest" label="拒付状态"></el-table-column>
        <el-table-column prop="tr_congeal" label="冻结状态"></el-table-column>
        <el-table-column prop="risk_method" label="Risk Method"></el-table-column>
        <el-table-column prop="mop_card_country" label="Risk 卡所属国家"></el-table-column>
        <el-table-column prop="mop_binname" label="Risk 发卡行"></el-table-column>
        <el-table-column prop="mop_countrycode" label="Risk IP国家"></el-table-column>
        <el-table-column prop="ci_experian_ip_city" label="Risk IP城市"></el-table-column>
        <el-table-column prop="ci_experian_risk_code" label="Risk Code"></el-table-column>
        <el-table-column prop="ci_client_id" label="客户端标识"></el-table-column>
        <el-table-column prop="ci_old_cookie" label="CookieId"></el-table-column>

      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: "OrderList",
  data() {
    return {
      loading: false,
      queryParams: {
        orderNo: "",
        bankOrderNo: "",
        trMerOrderno: "",
        status: "",
        refundment:"",
        protest:"",
        congeal:"",
        ciCardtype:"",
        merNo: "",
        merNo1: "",
        address:"",
        ciTel:"",
        startTime: "",
        endTime: "",
        ipAddress: "",
        ciEmail: "",
        fullName: "",
        firstname: "",
        lastname: "",
        cardSha: "",
        cardnopart: "",
        ciCountry: "",
        cilsuingBank: "",
        experianCardIssuer: "",
        ciAcquirer: "",
        trChaCode: "",
        chaName: "",
        mopCardCountry: ""

      },
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询
      // 模拟原始数据（实际应从接口获取）
      rawData: [
        { orderNo: "DD20251001001", customer: "张三", amount: 299, status: "pending", createTime: "2025-10-01 10:20:30" },
        { orderNo: "DD20251002002", customer: "李四", amount: 199, status: "completed", createTime: "2025-10-02 14:15:00" },
        { orderNo: "DD20251003003", customer: "王五", amount: 99, status: "cancelled", createTime: "2025-10-03 09:05:22" },
        { orderNo: "DD20251004004", customer: "赵六", amount: 399, status: "pending", createTime: "2025-10-04 16:30:10" },
        { orderNo: "DD20251005005", customer: "孙七", amount: 599, status: "completed", createTime: "2025-10-05 11:45:00" },
        { orderNo: "DD20251006006", customer: "周八", amount: 89, status: "pending", createTime: "2025-10-06 08:20:15" },
        { orderNo: "DD20251007007", customer: "吴九", amount: 499, status: "completed", createTime: "2025-10-07 13:10:40" },
        { orderNo: "DD20251008008", customer: "郑十", amount: 129, status: "cancelled", createTime: "2025-10-08 17:55:30" },
      ],
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      statusMap: {
        "-2": "warning",    // 待确认 - 黄色
        "-1": "info",       // 待处理 - 蓝色
        "0": "danger",      // 失败 - 红色
        "1": "success",     // 成功 - 绿色
      },
      statusText: {
        "-2": "待确认",
        "-1": "待处理",
        "0": "失败",
        "1": "成功",
      },
    };
  },
  created() {
   // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    this.setDefaultTime(); //时间设置
  },
  methods: {
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.queryParams.startTime) {
        this.queryParams.startTime = this.getDefaultStartTime();
      }
      if (!this.queryParams.endTime) {
        this.queryParams.endTime = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
     // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
  /*    const now = new Date();
      const oneYearAgo = new Date(now);
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      return this.formatDateTime(oneYearAgo);*/
   /*   const now = new Date();
      const oneYearAgo = new Date(now);
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      // 重置为当天 00:00:00
      oneYearAgo.setHours(0, 0, 0, 0);
      return this.formatDateTime(oneYearAgo);*/
      const now = new Date();

      // 1. 获取当前时间的毫秒时间戳
      const currentTimestamp = now.getTime();

      // 2. 计算2天的毫秒数 (2 * 24小时 * 60分钟 * 60秒 * 1000毫秒)
      const twoDaysInMs = 2 * 24 * 60 * 60 * 1000;

      // 3. 用当前时间戳减去2天的毫秒数
      const twoDaysAgoTimestamp = currentTimestamp - twoDaysInMs;

      // 4. 基于新的时间戳创建日期对象
      const twoDaysAgo = new Date(twoDaysAgoTimestamp);

      // 5. 重置为当天 00:00:00 (注意：这里重置的是"2天前"那天的0点)
      twoDaysAgo.setHours(0, 0, 0, 0);

      return this.formatDateTime(twoDaysAgo);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    // 过滤数据（模拟后端查询）
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          orderNo: this.queryParams.orderNo || undefined,
          bankOrderNo: this.queryParams.bankOrderNo || undefined,
          trMerOrderno: this.queryParams.trMerOrderno || undefined,
          status: this.queryParams.status || undefined,
          refundment: this.queryParams.refundment || undefined,
          protest: this.queryParams.protest || undefined,
          congeal: this.queryParams.congeal || undefined,
          ciCardtype: this.queryParams.ciCardtype || undefined,
          merNo: this.queryParams.merNo || undefined,
          merNo1: this.queryParams.merNo1 || undefined,
          address: this.queryParams.address || undefined,
          ciTel: this.queryParams.ciTel || undefined,
          ipAddress: this.queryParams.ipAddress || undefined,
          ciEmail: this.queryParams.ciEmail || undefined,
          fullName: this.queryParams.fullName || undefined,
          firstname: this.queryParams.firstname || undefined,
          lastname: this.queryParams.lastname || undefined,
          cardSha: this.queryParams.cardSha || undefined,
          cardnopart: this.queryParams.cardnopart || undefined,
          ciCountry: this.queryParams.ciCountry || undefined,
          cilsuingBank: this.queryParams.cilsuingBank || undefined,
          experianCardIssuer: this.queryParams.experianCardIssuer || undefined,
          ciAcquirer: this.queryParams.ciAcquirer || undefined,
          trChaCode: this.queryParams.trChaCode || undefined,
          chaName: this.queryParams.chaName || undefined,
          mopCardCountry: this.queryParams.mopCardCountry || undefined,


          startTime: this.queryParams.startTime || undefined,
          endTime: this.queryParams.endTime || undefined,
          page: this.pagination.page,
          size: this.pagination.size,
        };

        const res = await this.$axios.post('/api/es/orders',  params );

        if (res.data.code === '200') {
          this.tableData = res.data.data.list || [];
          this.pagination.total = res.data.data.total || 0;
          if(this.pagination.total > 0){
            this.hasSearched = true;
          }
        } else {
          console.log("测试登录失败"+res)
          this.$message.error(res.data.message || '查询失败');
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        if (err.response){
          console.log("测试登录过期 - 完整错误对象:", err.response);
          console.log("测试登录过期 - 状态码:", err.response.status);
          console.log("测试登录过期 - 响应数据:", err.response.data);
          console.log("测试登录过期 - 响应数据(JSON):", JSON.stringify(err.response.data, null, 2));

              if(err.response.status === 401){
                const message = err.response.data.message || '登录已经过期';
                console.log("登录失效消息:", message);
                this.$message.error(message);

                // 清除本地 token 并跳转到登录页
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("user");
                this.$router.push('/login');
              }
        }

        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
    /*  this.pagination.size = val;
      this.filterData();*/
      this.pagination.size = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
     /* this.pagination.page = val;
      this.filterData();*/

      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 下载
/*    downloadCsv() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return;
      }

      // 获取 token
      const token = sessionStorage.getItem("token");
      if (!token) {
        this.$message.error('登录已过期，请重新登录');
        this.$router.push('/login');
        return;
      }

      // 动态创建 form 进行提交
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/api/es/exportTrades';
      form.target = '_blank'; // 新窗口打开，避免当前页跳转
      form.style.display = 'none';

      // 添加查询参数
      const paramsInput = document.createElement('input');
      paramsInput.type = 'hidden';
      paramsInput.name = 'params';
      paramsInput.value = JSON.stringify(this.queryParams);
      form.appendChild(paramsInput);

      // 添加 token 参数
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'token';
      tokenInput.value = token;
      form.appendChild(tokenInput);

      // 提交并清理
      document.body.appendChild(form);
      form.submit();
      setTimeout(() => document.body.removeChild(form), 1000);

      this.$message.success('开始下载，请查看浏览器下载列表...');
    },*/


    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },

    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.queryParams[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },

   /* confirmMoreInput() {
      this.queryParams[this.currentField] = this.moreInput; // ✅ 完全原样保存
      this.closeMoreDialog();
    },*/
    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
        .split('#')
        .map(item => item.trim())  // 去掉每个值的前后空格
        .filter(item => item.length > 0)  // 过滤空值
        .join('#');  // 用 # 重新连接

      this.queryParams[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
}
</style>

<style scoped>


/* 禁止表格内容换行，超长显示省略号 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
/* 表头也禁止换行 */
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
/* 确保表格容器可以横向滚动 */
.table-card {
  overflow-x: auto;
}
/* 调整表格最小宽度，确保所有列能正常显示 */
.table-card ::v-deep .el-table {
  min-width: 100%;
}

.order-list {
  padding: 20px;
}
.query-card ::v-deep .el-form-item {
  margin-bottom: 10px;
}
/* 确保所有.el-input, .el-date-picker等具有相同的宽度 */
.query-card ::v-deep .el-input__inner,
.query-card ::v-deep .el-date-editor {
  width: 200px; /* 可根据需要调整 */
}

/* 调整.el-form-item的默认margin-bottom以保持一致性 */
.query-card ::v-deep .el-form-item {
  margin-bottom: 10px;
}

/* 确保带有More按钮的输入框整体对齐 */
.query-card ::v-deep .inline-flex-container {
  display: flex;
  align-items: center;
}

.query-card ::v-deep .inline-flex-container .el-input {
  margin-right: 8px; /* 为More按钮留出空间 */
}
</style>



// WEBPACK FOOTER //
// src/view/order/ListPage.vue